export class TeamLeader {
  id: number
  teamLeadId: number
  name: string
  isApproverVR: boolean
  isReceiverVREmail: boolean
}
